import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BlogBlockHeading } from '../blog.models';

@Component({
  selector: 'app-blog-block-heading',
  templateUrl: './block-heading.component.html',
  styleUrls: ['./block-heading.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogBlockHeadingComponent {
  @Input({ required: true }) block!: BlogBlockHeading;

  get level(): 1 | 2 | 3 {
    const raw = Number(this.block?.level ?? 2);
    if (raw <= 1) {
      return 1;
    }
    if (raw >= 3) {
      return 3;
    }
    return 2;
  }
}
